/**
 * Brand
 * This is a grouping component for the Forge brand icon and text, making up the full lockup
 */
import { createStyles, withStyles, Divider } from '@material-ui/core';
import BrandIcon from '../BrandIcon';
import React from 'react';
import clsx from 'clsx';
// this object definition is required to support the classes interface below all styles for these classes are defined
// in the mui-config overrides under the MuiBrand key
const styles = () => createStyles({
    root: {
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'flex-start',
        position: 'relative',
        textAlign: 'left',
        verticalAlign: 'middle',
        userSelect: 'none',
        width: '100%',
    },
    icon: {
        display: 'inline-flex',
        flexShrink: 0,
    },
    divider: {},
    text: {
        flex: '1 1 auto',
    },
});
const Brand = props => {
    const { className, classes, ...rest } = props;
    return (React.createElement("div", Object.assign({ className: clsx(classes.root, className) }, rest),
        React.createElement("div", { className: classes.icon },
            React.createElement(BrandIcon, null)),
        React.createElement(Divider, { className: classes.divider, orientation: "vertical" }),
        React.createElement("div", { className: classes.text }, props.children || 'Forge')));
};
export default withStyles(styles, { name: 'MuiBrand' })(Brand);
//# sourceMappingURL=Brand.js.map